export const closeCircle = {
  name: "close-circle" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 3.818a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6.327-3.673a.91.91 0 0 1 1.286 0L12 10.714l2.387-2.387a.909.909 0 1 1 1.286 1.286L13.286 12l2.387 2.387a.909.909 0 1 1-1.286 1.286L12 13.286l-2.387 2.387a.909.909 0 1 1-1.286-1.286L10.714 12 8.327 9.613a.91.91 0 0 1 0-1.286Z" clip-rule="evenodd"/></svg>`,
  keywords: ["close-circle"],
  category: "other" as const,
};
